export const featuresFlags ={
    SINGLE_DASHBOARD : true
}